import type { VendorPortalUserPrefs } from '../types';

export function shouldAutoStartTour(
  prefs: VendorPortalUserPrefs | null | undefined,
  orgId: string | undefined,
): boolean {
  if (!orgId) return false;
  if (!prefs) return true;
  if (prefs.tourCompletedByOrg?.[orgId]) return false;
  if (prefs.tourSkippedByOrg?.[orgId]) return false;
  return true;
}
